"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.fieldsetter = exports.relativeFieldset = exports.FieldsetContext = void 0;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _recompose = require("recompose");

var _utils = require("../../../utils");

var FieldsetContext = /*#__PURE__*/(0, _react.createContext)({
  fieldset: undefined
});
exports.FieldsetContext = FieldsetContext;

var relativeFieldset = function relativeFieldset(parentField, childField) {
  if (!(0, _utils.isEmpty)(parentField) && !(0, _utils.isEmpty)(childField)) {
    return parentField + "." + childField;
  } else if (!(0, _utils.isEmpty)(parentField)) {
    return parentField;
  } else if (!(0, _utils.isEmpty)(childField)) {
    return childField;
  }

  return '';
};

exports.relativeFieldset = relativeFieldset;

var fieldsetter = function fieldsetter(Fieldset) {
  var FieldsetedFieldset = function FieldsetedFieldset(_ref) {
    var fieldset = _ref.fieldset,
        rest = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["fieldset"]);

    var _useContext = (0, _react.useContext)(FieldsetContext),
        parentField = _useContext.fieldset;

    return /*#__PURE__*/_react.default.createElement(FieldsetContext.Provider, {
      value: {
        fieldset: relativeFieldset(parentField, fieldset)
      }
    }, /*#__PURE__*/_react.default.createElement(Fieldset, rest));
  };

  FieldsetedFieldset.displayName = "Fieldseted" + (Fieldset.displayName || Fieldset.name);
  FieldsetedFieldset.propTypes = {
    fieldset: _propTypes.default.string
  };
  return FieldsetedFieldset;
};

exports.fieldsetter = fieldsetter;

var _default = (0, _recompose.branch)(function (_ref2) {
  var fieldset = _ref2.fieldset;
  return !(0, _utils.isEmpty)(fieldset);
}, fieldsetter);

exports.default = _default;